import React, { Component } from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FONT_SIZE_OPTIONS,
  FONT_SIZE_OPTIONS_MAP,
} from "../../constants/document";
import { checkStylesInSelection } from "../../utils/editorUtils";

// Decalarations
const DEFAULT_FONT_SIZE = "14";

export default class CustomSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontSizeTitle: DEFAULT_FONT_SIZE,
    };
  }

  componentWillMount = () => {
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentDidMount = () => {
    const { isFound, fontSize } = this._getFontData(this.props.editorState);
    if (isFound && fontSize) {
      this.setState({
        fontSizeTitle: fontSize,
      });
    }
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }

    if (!isFound) {
      const newBlockType = this._getBlockType(this.props.editorState);
      if (newBlockType) {
        this.setState({
          fontSizeTitle: this._checkStyleOnLoad(newBlockType),
        });
      }
    }
  };

  componentDidUpdate = prevProps => {
    if (
      prevProps.editorState.getSelection().getFocusOffset() !==
        this.props.editorState.getSelection().getFocusOffset() &&
      !this.props.editorState.getSelection().isCollapsed()
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(editorState, "FONTSIZE");
      if (checkCount > 1) {
        this.setState({
          fontSizeTitle: null,
        });
        return;
      }
    }
    if (
      prevProps.editorState.getSelection().getAnchorOffset() !==
        this.props.editorState.getSelection().getAnchorOffset() ||
      (prevProps.editorState.getSelection().getFocusOffset() !==
        prevProps.editorState.getSelection().getAnchorOffset() &&
        this.props.editorState.getSelection().getFocusOffset() ===
          this.props.editorState.getSelection().getAnchorOffset())
    ) {
      const { editorState } = this.props;
      const checkCount = checkStylesInSelection(editorState, "FONTSIZE");
      if (checkCount > 1) {
        this.setState({
          fontSizeTitle: null,
        });
        return;
      }
      const { isFound, fontSize } = this._getFontData(this.props.editorState);
      if (isFound && fontSize) {
        this.setState({
          fontSizeTitle: fontSize,
        });
      }
      if (!isFound) {
        this.setState({
          fontSizeTitle: this._checkStyleOnMoment(this.props.editorState),
        });
      }
    } else {
      const oldBlockType = this._getBlockType(prevProps.editorState);
      const newBlockType = this._getBlockType(this.props.editorState);
      let isSizeChanged = false;
      if (
        prevProps.metaData &&
        prevProps.metaData.FONTSIZE &&
        this.props.metaData &&
        this.props.metaData.FONTSIZE &&
        FONT_SIZE_OPTIONS[this.props.metaData.FONTSIZE].fontSize !==
          FONT_SIZE_OPTIONS[prevProps.metaData.FONTSIZE].fontSize
      ) {
        isSizeChanged = true;
      }
      if (oldBlockType !== newBlockType || isSizeChanged) {
        this.setState({
          fontSizeTitle: this._checkStyleOnLoad(newBlockType),
        });
      }
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _getFontData = editorState => {
    let sizeFound = false;
    let foundFontSize = "";
    Object.entries(FONT_SIZE_OPTIONS).forEach(([key, value]) => {
      if (editorState.getCurrentInlineStyle().has(key)) {
        sizeFound = true;
        foundFontSize = FONT_SIZE_OPTIONS_MAP[value.fontSize] || "";
      }
    });
    return {
      isFound: sizeFound,
      fontSize: foundFontSize,
    };
  };

  _handleClick = e => {
    if (
      !this.node.contains(e.target) &&
      this.props.activeToolbarDropDown === "FONT_SIZE"
    ) {
      this.props.toogleToolbarDropDown(null);
    }
  };

  _getBlockType = editorState => {
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    const blockKey = selectionState.getAnchorKey();
    const blockType = contentState.getBlockForKey(blockKey).getType();
    return blockType;
  };

  // header sizes must be equal to what is declared in _document.css
  _checkStyleOnLoad = blockType => {
    let fontsize = null;
    if (blockType === "header-one") {
      fontsize = 36;
    }
    if (blockType === "header-two") {
      fontsize = 30;
    }
    if (blockType === "header-three") {
      fontsize = 24;
    }
    if (blockType === "header-four") {
      fontsize = 18;
    }
    if (
      blockType === "unordered-list-1" ||
      blockType === "ordered-list-1" ||
      blockType === "unstyled"
    ) {
      Object.entries(FONT_SIZE_OPTIONS).forEach(([key, value]) => {
        if (this.props.editorState.getCurrentInlineStyle().has(key)) {
          fontsize = FONT_SIZE_OPTIONS_MAP[value.fontSize];
        }
      });
    }

    if (fontsize === null) {
      const { editorState, metaData } = this.props;
      if (
        metaData &&
        metaData.FONTSIZE &&
        editorState.getSelection().getAnchorOffset() === 0
      ) {
        fontsize =
          FONT_SIZE_OPTIONS_MAP[
            FONT_SIZE_OPTIONS[metaData.FONTSIZE].fontSize
          ] || "";
      }
    }

    return fontsize || DEFAULT_FONT_SIZE;
  };

  _checkStyleOnMoment = newEditorState => {
    const newBlockType = this._getBlockType(newEditorState);
    let fontSize = DEFAULT_FONT_SIZE;
    fontSize = this._checkStyleOnLoad(newBlockType);
    return fontSize;
  };

  _saveMetaData = fontSizeKey => {
    const data = [
      {
        op: "replace",
        field: "meta_data",
        value: {
          meta_data: {
            ...this.props.metaData,
            FONTSIZE: fontSizeKey,
          },
        },
      },
    ];

    this.props.saveMetaData(data);
  };

  _onChange = (event, fontSizeKey, fontSizeValue) => {
    event.preventDefault();
    this._saveMetaData(fontSizeKey);
    this.props.sizeUpdate("FONTSIZE", fontSizeKey);
    this.setState({
      fontSizeTitle: fontSizeValue,
    });
    this.props.toogleToolbarDropDown(null);
  };

  _toggleDropdown = event => {
    event.preventDefault();
    this.props.toogleToolbarDropDown(
      this.props.activeToolbarDropDown === "FONT_SIZE" ? null : "FONT_SIZE",
    );
  };

  render() {
    return (
      <div
        className="draft-edit-items"
        ref={ele => {
          this.node = ele;
        }}>
        <Tooltip
          placement="top"
          overlay="Font size"
          align={{
            offset: [3, 0],
          }}>
          <button
            data-test="revv-toolbar-custom-size-button"
            className={`toolbar-custom-inline-button toolbar-btn option-font-size ${
              this.props.activeToolbarDropDown === "FONT_SIZE" ? "active" : ""
            }`}
            type="button"
            onMouseDown={this._toggleDropdown}>
            <span className="font-size-tile">{this.state.fontSizeTitle}</span>
            <i className="ic-dropdown">
              <FontAwesomeIcon
                icon={["far", "angle-down"]}
                className="breadcrumb-bredcrumb-icon"
              />
            </i>
          </button>
        </Tooltip>
        {this.props.activeToolbarDropDown === "FONT_SIZE" && (
          <div className="customsize-style-wrapper">
            <div className="customsize-style-fontoptions-wrapper">
              <ul className="customsize-style-fontoptions show-scrollbar">
                {Object.entries(FONT_SIZE_OPTIONS).map(([key, value]) => (
                  <li
                    key={key}
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                    role="button"
                    tabIndex={0}
                    onMouseDown={e =>
                      this._onChange(
                        e,
                        key,
                        FONT_SIZE_OPTIONS_MAP[value.fontSize],
                      )
                    }>
                    <div
                      className={`customsize-style-fontoption ${
                        this.state.fontSizeTitle ===
                        FONT_SIZE_OPTIONS_MAP[value.fontSize]
                          ? "active"
                          : ""
                      }`}>
                      {FONT_SIZE_OPTIONS_MAP[value.fontSize]}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/CustomSize.js